import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { strategyApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { StrategyFormData } from '../types/strategy';

export function useCreateStrategy() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (formData: StrategyFormData) => strategyApi.createStrategy(formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.strategies.lists() });
      toast.success('Strategy created successfully!');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to create strategy');
    },
  });
}
